/* src/app/newsletter/newsletter.component.css */
#container {
  height: 60rem;
  width: 100%;
}
#legendItems {
  font-size: medium;
  text-align: left;
}
.legendRed {
  color: red;
}
.legendGreen {
  color: green;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  #container {
    height: 50rem;
    width: 33rem;
  }
}
#copy {
  width: 18rem;
  margin: auto;
  width: 50%;
  text-align: center;
}
th {
  padding-right: 10px;
}
.perfCon {
  height: max-content;
  width: max-content;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  #container {
    height: 50rem;
  }
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .perfCon {
    height: 50rem;
    width: 32rem;
    margin: auto;
  }
}
.perfMarg {
  margin-left: 17%;
  margin-right: 17%;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .perfMarg {
    margin: auto;
  }
}
.copiersCon {
  width: 90rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .copiersCon {
    width: 32rem;
    height: 50rem;
  }
}
.riskCon {
  width: 90rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .riskCon {
    width: 32rem;
    height: 50rem;
  }
}
.portfolioTab {
  margin-left: 3rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .portfolioTab {
    width: 10rem;
    font-size: small;
  }
}
.templateCharts {
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .templateCharts {
    margin-top: 10rem;
  }
}
.portHeading {
  padding-right: 14rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .portHeading {
    padding-right: 5px;
  }
}
.portLeft {
  padding-left: 14rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .portLeft {
    padding-left: 0rem;
  }
}
.mobileTab {
  margin-top: 2rem;
  padding-bottom: 1rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .mobileTab {
    margin-top: 13rem;
    overflow: hidden;
  }
}
.feedTab {
  margin-left: 18%;
  margin-right: 18%;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .feedTab {
    margin-left: 0rem;
    margin-right: 0rem;
  }
}
.navItems {
  padding-right: 4rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .navItems {
    padding-right: 1rem;
  }
}
.navText {
  font-size: large;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .mobileAvgCop {
    margin-bottom: 1.5rem;
  }
}
.avgMarg {
  margin-left: 17%;
  margin-right: 17%;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .avgMarg {
    margin: auto;
  }
}
.copyMarg {
  margin-left: 17%;
  margin-right: 17%;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .copyMarg {
    margin: auto;
  }
}
.err {
  text-align: center;
  padding-top: 12%;
  padding-bottom: 12%;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .err {
    text-align: center;
    padding-top: 10rem;
    padding-bottom: 10rem;
  }
}
.btn {
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: red;
  border-radius: 0.4rem;
  font-weight: 700;
  color: #fff;
  border: 0.2rem solid red;
  min-width: 5rem;
  padding: 0 1rem;
  -webkit-transition:
    background-color 0.4s,
    border-color 0.4s,
    color 0.4s;
  -o-transition:
    background-color 0.4s,
    border-color 0.4s,
    color 0.4s;
  transition:
    background-color 0.4s,
    border-color 0.4s,
    color 0.4s;
  min-height: 2rem;
  line-height: 5.6rem;
  font-size: 1.2rem;
}
.btn:hover {
  background-color: #fff;
  color: red;
}
.btn--secondary {
  min-width: 10.7rem;
  background-color: transparent;
  min-height: 4.6rem;
  line-height: 4.2rem;
  font-size: 1.6rem;
  font-family:
    "Poppins",
    Helvetica,
    Arial,
    sans-serif;
  color: red;
}
#container {
  height: 60rem;
  width: 100%;
}
#legendItems {
  font-size: medium;
  text-align: left;
}
.legendRed {
  color: red;
}
.legendGreen {
  color: green;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  #container {
    height: 50rem;
  }
}
#legend {
  margin-left: 50rem;
  padding-left: 1rem;
  padding-top: 1rem;
  color: white;
  margin-bottom: 2%;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  #legend {
    margin-left: 0rem;
    padding-left: 1rem;
    padding-top: 1rem;
    color: white;
    margin-bottom: 2%;
  }
}
.legendGrad {
  background-image:
    linear-gradient(
      to right,
      #BACEE7,
      #ACC0E1,
      white);
}
.legendShadow {
  box-shadow: 1px 2px 14px rgba(0, 0, 0, .5);
}
.legendRed {
  color: red;
}
.legendGreen {
  color: green;
}
#legendItems {
  width: 155%;
}
#container {
  height: 75rem;
  width: 100%;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  #container {
    height: 50rem;
  }
}
.brochurePos {
  margin-left: 0rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .brochurePos {
    margin-left: 2.5rem;
  }
}
#about {
}
.nsdqChart {
  width: 840px;
  height: 680px;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .nsdqChart {
    width: 100%;
    height: 280px;
  }
  .highcharts-legend {
    pointer-events: none;
  }
}
.btn {
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: #5ECE42;
  border-radius: 10px;
  font-weight: 700;
  color: #fff;
  border: 0.2rem solid #5ECE42;
  min-width: 23.6rem;
  padding: 0 1rem;
  -webkit-transition:
    background-color 0.4s,
    border-color 0.4s,
    color 0.4s;
  -o-transition:
    background-color 0.4s,
    border-color 0.4s,
    color 0.4s;
  transition:
    background-color 0.4s,
    border-color 0.4s,
    color 0.4s;
  min-height: 6rem;
  line-height: 5.6rem;
  font-size: 1.8rem;
}
.btn {
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: #5ECE42;
  border-radius: 10px;
  font-weight: 700;
  color: #fff;
  border: 0.2rem solid #5ECE42;
  min-width: 23.6rem;
  padding: 0 1rem;
  -webkit-transition:
    background-color 0.4s,
    border-color 0.4s,
    color 0.4s;
  -o-transition:
    background-color 0.4s,
    border-color 0.4s,
    color 0.4s;
  transition:
    background-color 0.4s,
    border-color 0.4s,
    color 0.4s;
  min-height: 6rem;
  line-height: 5.6rem;
  font-size: 1.8rem;
}
.btn:hover {
  background-color: #fff;
  color: #5ECE42;
}
.btn--size-1 {
  min-width: 6.3rem;
  min-height: 4.6rem;
  line-height: 4.2rem;
  font-size: 1.6rem;
  font-family:
    "Poppins",
    Helvetica,
    Arial,
    sans-serif;
}
.btn--size-2 {
  min-width: 26.6rem;
  min-height: 7rem;
  line-height: 6.6rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .btn--size-2 {
    font-size: 2rem;
  }
}
.btn--size-3 {
  min-width: 14.2rem;
  min-height: 7rem;
  line-height: 6.6rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .btn--size-3 {
    min-width: 12rem;
    min-height: 5rem;
    line-height: 4.6rem;
  }
}
.btn--size-4 {
  min-width: 21.2rem;
  min-height: 7rem;
  line-height: 7rem;
}
.btn--size-5 {
  min-width: 22.5rem;
  min-height: 7rem;
  line-height: 6.6rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .btn--size-5 {
    min-height: 6.3rem;
    line-height: 5.9rem;
  }
}
.btn--secondary {
  min-width: 10.7rem;
  background-color: transparent;
  min-height: 4.6rem;
  line-height: 4.2rem;
  font-size: 1.6rem;
  font-family:
    "Poppins",
    Helvetica,
    Arial,
    sans-serif;
}
.btn--secondary:hover {
  background-color: #5ECE42;
  color: #fff;
}
.btn--alt {
  min-width: 30rem;
  min-height: 7rem;
  line-height: 6.4rem;
  background-color: #2C3B51;
  border: 0.2rem solid #2C3B51;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .btn--alt {
    min-width: 23rem;
  }
}
.btn--alt:hover {
  background-color: #5ECE42;
  border-color: #5ECE42;
  color: #fff;
}
.btn--dark {
  min-width: 21.4rem;
  min-height: 7rem;
  line-height: 7rem;
  background-color: #000;
  -webkit-box-shadow: 20px 20px 15px 5px rgba(0, 0, 0, 0.15);
  box-shadow: 20px 20px 15px 5px rgba(0, 0, 0, 0.15);
  border: none;
  border-radius: 10px;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .btn--dark {
    min-width: 24.8rem;
  }
}
.btn--dark:hover {
  color: #fff;
  background-color: #5ECE42;
}
.btn--transparent {
  min-width: 13.2rem;
  min-height: 4.6rem;
  line-height: 4.2rem;
  border-color: #898FB5;
  background-color: transparent;
  font-size: 1.6rem;
  font-family:
    "Poppins",
    Helvetica,
    Arial,
    sans-serif;
}
.btn--transparent:hover {
  background-color: #898FB5;
}
.btn--xs {
  position: relative;
  min-width: 4.6rem;
  min-height: 4.6rem;
}
.btn--xs img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.btn--block {
  display: block;
  padding-left: 0;
  padding-right: 0;
}
::ng-deep .eapps-facebook-feed-popup-item-info {
  overflow: scroll !important;
}
@media only screen and (max-width: 640px) {
  ::ng-deep .eapps-facebook-feed-popup-close {
    background-color: black;
    border-radius: 100%;
  }
}
@media only screen and (max-width: 640px) {
  ::ng-deep .eapps-facebook-feed-popup-close {
    opacity: 34% !important;
  }
}
/*# sourceMappingURL=newsletter.component.css.map */
